import Block from '../block'

export default class Accordion extends Block {
	static title = 'accordion'

	init() {
		this.toggleElement = this.getElement('toggle')
		this.containerElement = this.getElement('container')
		this.contentElement = this.getElement('content')

		if (!this.toggleElement || !this.contentElement || !this.containerElement) {
			return
		}

		if (this.element.classList.contains('accordion--active')) {
			this.setActive()
		}

		this.toggleElement.addEventListener('click', () => this.toggleAccordion())
	}

	setActive() {
		this.element.classList.add('accordion--active')
		this.containerElement.style.height = `${this.contentElement.offsetHeight}px`
	}

	setInactive() {
		this.element.classList.remove('accordion--active')
		this.containerElement.style.height = '0px'
	}

	toggleAccordion() {
		this.element.classList.toggle('accordion--active')

		if (!this.element.classList.contains('accordion--active')) {
			this.containerElement.style.height = '0px'
			return
		}

		this.containerElement.style.height = `${this.contentElement.offsetHeight}px`

		if (this.element.classList.contains('accordion--standalone')) {
			return
		}

		Array.from(document.querySelectorAll('.accordion')).forEach(accordion => {
			if (accordion === this.element) {
				return
			}
			accordion.ref.setInactive()
		})
	}
}
